import React from "react";
import { gaWhatsappClick } from "../lib/analytics";

/**
 * Floating WhatsApp button. Pure SVG icon (no emoji).
 */
export default function WhatsAppButton({ phone = "13107706585", message = "Hello, I'd like to inquire about Pacific Key Management." }) {
    const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float-button"
            aria-label="Chat on WhatsApp"
            onClick={() => gaWhatsappClick({ cta_location: "floating_button" })}
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl whatsapp-attention hover:scale-105 transition-transform duration-300"
        >
            <svg viewBox="0 0 32 32" className="w-7 h-7 fill-current" aria-hidden="true">
                <path d="M19.11 17.42c-.27-.13-1.58-.78-1.82-.87-.24-.09-.42-.13-.6.13-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.11-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.82-1.98-.22-.52-.44-.45-.6-.46l-.51-.01c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22 0 1.31.95 2.57 1.08 2.75.13.18 1.87 2.86 4.54 4 .63.27 1.13.43 1.51.55.63.2 1.21.17 1.66.1.51-.08 1.58-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.24-.18-.51-.31zM16.04 4C9.98 4 5.04 8.94 5.04 15c0 1.92.5 3.8 1.46 5.44L5 28l7.8-2.04A10.9 10.9 0 0 0 16.04 26c6.06 0 11-4.94 11-11s-4.94-11-11-11zm0 20.07c-1.76 0-3.49-.47-5-1.36l-.36-.22-4.62 1.21 1.23-4.5-.23-.37A8.96 8.96 0 1 1 25 15c0 4.97-4.03 9.07-8.96 9.07z"/>
            </svg>
        </a>
    );
}
